

import * as fromUI from './ui.accions';
import { UploadFile } from '../shared.model';
import { AppState } from '../../app.reducer';

export interface State {
    isLoading: boolean;
    lang: string;
}

export interface UploadFilesState {
    items: UploadFile[];
}

// export interface UploadFilesAppState {
//     upload_files: UploadFilesState;
// }

// const uploadFileInitialState: UploadFilesState = {
//     items: [],
// };

const initState: State = {
    isLoading: false,
    lang: 'es',
};

export function uiReducer(state = initState, action: fromUI.acciones): State {

    switch (action.type) {

        case fromUI.ACTIVAR_LOADING:
            return {
                ...state,
                isLoading: true
            };

        case fromUI.DESACTIVAR_LOADING:
            return {
                ...state,
                isLoading: false
            };

        case fromUI.SET_IDIOMA:
            return {
                ...state,
                lang: action.lang.slice(0)
            };

        default:
            return state;
    }
}

// export function uiFilesReducer(state = uploadFileInitialState, action: fromUI.acciones): UploadFilesState {

//     switch (action.type) {

//         case fromUI.ADD_FILE:
//             return {
//                 ...state,
//                 items: [...state.items, action.file]
//             };

//         case fromUI.SET_FILES:
//             return {
//                 ...state,
//                 items: [
//                     ...action.files.map(item => {
//                         return {
//                             ...item
//                         };
//                     })
//                 ]
//             };

//         case fromUI.DELETE_FILE:
//             return {
//                 ...state,
//                 items: state.items.filter(file => file.id !== action.id)
//             };

//         case fromUI.SET_FILE_UPLOAD_COMPLETED:
//             return {
//                 ...state,
//                 items: state.items.map(uploadFile => {

//                     if (uploadFile.id === action.id) {
//                         return {
//                             ...uploadFile,
//                             completed: !uploadFile.completed
//                         };
//                     } else {
//                         return uploadFile;
//                     }

//                 }),
//             };

//         case fromUI.UNSET_FILES:
//             return {
//                 ...state,
//                 items: []
//             };

//         default:
//             return state;
//     }
// }
